export default __webpack_public_path__ + "static/media/15-460x460.3dff24a4.jpeg";